module.exports = __webpack_public_path__ + "static/media/pierre-cover.c5795b5a.jpeg";